import { z } from "zod";
import { Id } from "./workspace.entity.ts";

export const AssignGrantInput = z
	.object({
		orgId: Id,
		targetUid: Id.describe("the member whose grant is being written"),
		scope: z.discriminatedUnion("kind", [
			z.object({ kind: z.literal("organization") }).strict(),
			z.object({ kind: z.literal("event"), eventId: Id }).strict(),
		]),
		roleId: Id.describe(
			"the role to assign — must exist in the org catalog and be ⊆ the caller's own role",
		),
	})
	.strict();
export type AssignGrantInput = z.infer<typeof AssignGrantInput>;

export const AssignGrantOutput = z.object({ ok: z.literal(true) }).strict();
export type AssignGrantOutput = z.infer<typeof AssignGrantOutput>;
